module.exports = __webpack_public_path__ + "static/media/scrim_command.11be3f26.mp4";